import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OmsServiceService } from '../services/oms-service.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddTestModalComponent } from '../modal-popups/add-test-modal/add-test-modal.component';
import { DeleteItemModalComponent } from '../modal-popups/delete-item-modal/delete-item-modal.component';
import { ConfirmModalComponent } from '../modal-popups/confirm-modal/confirm-modal.component';
import { ReAllocationComponent } from '../modal-popups/re-allocation/re-allocation.component';
import { SamplesCollectedComponent } from '../modal-popups/samples-collected/samples-collected.component';
import { SamplesSubmitedComponent } from '../modal-popups/samples-submited/samples-submited.component';
import { ItemsReassignModalComponent } from '../modal-popups/items-reassign-modal/items-reassign-modal.component';
import { ConstantsService } from '../services/constants.service';
//import { ReScheduleItemComponent } '../modal-popups/re-schedule-item/re-schedule-item.component';
import { ReScheduleItemComponent } from '../modal-popups/re-schedule-item/re-schedule-item.component';
//UploadReportComponent
//import { UploadReportComponent } from '../modal-popups/upload-report/upload-report.component';
import { SharedService } from '../../../../tools/src/lib/shared/shared.service'
import { configurton } from '../../../../l2-radiology/src/assets/data/configuration';
import { OrderCancelModelComponent } from '../modal-popups/order-cancel-model/order-cancel-model.component'
import { NgxSpinnerService } from "ngx-spinner";
//
import { UploadReportDataComponent } from '../modal-popups/upload-report-data/upload-report-data.component';
import { VerityOtpComponent } from '../modal-popups/verity-otp/verity-otp.component';
import { actionButtonConfiguration } from '../../../../l2-radiology/src/assets/data/actionButtonConfiguration';
import { PrescriptionUploadComponent } from '../modal-popups/prescription-upload/prescription-upload.component';
import { OrderRejectModalComponent } from '../modal-popups/order-reject-modal/order-reject-modal.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, FormControl, FormsModule, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { EconsultReassignModalComponent } from '../modal-popups/econsult-reassign-modal/econsult-reassign-modal.component';
import { GeneratePaymentLinkComponent } from '../modal-popups/generate-payment-link/generate-payment-link.component';
import { PreAssessmentFormComponent } from '../pre-assessment-form/pre-assessment-form.component';

@Component({
  selector: 'app-escalation-details',
  templateUrl: './escalation-details.component.html',
  styleUrls: ['./escalation-details.component.scss']
})
export class EscalationDetailsComponent implements OnInit {
  
   constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private omsServiceService: OmsServiceService,
    private modalService: NgbModal,
    private constantsService: ConstantsService,
    private sharedService: SharedService,
    private SpinnerService: NgxSpinnerService,
    public ngbActiveModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private toastr: ToastrService
  ) { }

  id: number;
  orderDetailsRes = {};
  orderRequest = {};
  orderInfo = {};
  closeResult: string;
  getStatus: any;
  totalNoofSesstions:any;

  prescriptionResponse = "";
  otpResponse = "";
  paymentDiffResponse = "";
  confirmOrderResponse = "";
  isPrescriptionSend = false;
  isPaymentDifferences = false;
  isConfirmedOrder = false;
  isEconConfirmedOrder = false;
  from_date: any;
  slotResponse = [];
  isOtpSend = false;
  slotTimingInfo: string = null;
  contactNumber = "";
  getdocuments = "";
  emailAddress = "";
  getFinalReportDocId = "";
  message = "";
  activeComponentId = "";
  sessionId: string = "";
  from: string = "";
  serviceType = "";
  serviceMode = "";
  modeOfService = "";

  isPendingPrescriptionLink: boolean = false;
  isPendingPrescriptionLinkStatus: boolean = false;
  isSendPaymentLink: boolean = false;



  role: string = "";
  configuraionData;
  actionButtonConfiguration;
  //configuration Data
  isOrderComplete: boolean = false;
  isUploadReport: boolean = false;
  isOtpVerifyLink: boolean = false;
  isPrescriptionLink: boolean = false;
  isOrderCancel: boolean = false;
  isReAssign: boolean = false;
  isAddItem: boolean = false;
  isDeleteItem: boolean = false;
  isConfirmScheduleDate: boolean = false;
  isReScheduleOrder: boolean = false;
  isViewPrescriptionLink: boolean = false;
  isSendPrescriptionLink: boolean = false;
  isViewReport: boolean = false;
  isOrderReject: boolean = false;
  isViewPaymentLink: boolean = true;
  isRendOtp: boolean = false;
  isSendOtp: boolean = false;
  fileDownloadDisable :Boolean =true;
  isPrescriptionUploadButton: Boolean = false;
  isUploadButtonReady: Boolean = false;
  labAvailableTimingsRes = {};
  uploadForm: FormGroup;
  documentType: string = "";
  roleBasedValue:any;
  vendor = new FormControl();
  vendorList:any;
  showVendor: boolean;
  selectValue = "";
  isReallocation: boolean = false;
  isTobeassigned: boolean = false;
  isReports: boolean = false;
  isCollectsample: boolean = false;
  isSubmitSample: boolean = false;
  assoc_data = {};
  officerAssocInfo : any;
  isReqReScheduleOrder: boolean = false;
  isReqCancelledOrder: boolean = false;
  isReportInput: boolean = true;
  remarks_Form!:FormGroup
  ngOnInit(): void {
    this.sharedService.setHideHeader(false);
    this.SpinnerService.show();
    this.actionButtonConfiguration = actionButtonConfiguration;
    this.sharedService.role.subscribe(role => {
      this.role = role;
    });
    this.role = localStorage.getItem("role");

    this._activatedRoute.params.subscribe(params => {
      this.id = params["orderId"];
      this.getStatus = params["statusId"];
      if(this.getStatus == 'reallocation'){
        this.isReallocation = true;
      }else if(this.getStatus == 'tobeassigned'){
        this.isTobeassigned = true;
      }else if(this.getStatus == 'reports'){
        this.isReports = true;
      }else if(this.getStatus == 'samplecollection'){
        this.isCollectsample = true;
      }else if(this.getStatus == 'samplesubmissions'){
        this.isSubmitSample = true;
      }

      this.getOrderDataById(this.id);
      // this.getVendorList();
    })

    this.uploadForm = this.formBuilder.group({
      profile: [''],
      uploadDoc:[''],
      documentType: ['',Validators.compose([Validators.required,])],
      finalReport: [''],
    });
    this.remarks_Form = this.formBuilder.group({
      remarks: ['', Validators.compose([Validators.required,])],
    })

    this.uploadForm = this.formBuilder.group({
      profile: [''],
      uploadDoc:[''],
      documentType: ['',Validators.compose([Validators.required,])],
      finalReport: [''],
    });

  }
uploadFile:any;
  onFileSelect(event) {
    this.uploadFile=''
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.uploadFile=event.target.files[0]
      this.uploadForm.get('profile').setValue(file);
    }
  }
  remarksSubmit(){
    let payload={
      "method": "OMS/api/v6/save/order/remarks",
      "type" : "post",
      "channelCode": 2,
      "orderIds": [
          this.id
      ],
      "actionById": window.localStorage.getItem('actionById'),
      "actionByName": window.localStorage.getItem('actionByName'),
      "remarks": this.remarks_Form.value.remarks
    }
    this.SpinnerService.show()
    this.omsServiceService.omsCommonMethod(payload).subscribe((res:any)=>{
      this.SpinnerService.hide()
      if(res[this.id].status == 1){
        this.toastr.success(res[this.id]["message"]);
        this.remarks_Form.reset()
        this.getOrderDataById(this.id);
      }else{
        this.toastr.error(res[this.id]["message"]);

      }
      
    })
  }
  getOrderDataById(id) {
    this.SpinnerService.show();
    this.orderRequest["actionById"] = window.localStorage.getItem('actionById');
    this.orderRequest["channelCode"] = this.constantsService.CHANNEL_CODE;
    this.orderRequest["order_id"] = id;
    this.orderRequest["action"] = "OMS/api/operation.php/v1/orderswithcount";
    this.orderRequest["type"] = "post";
    this.omsServiceService.getOrderDetails(this.orderRequest).subscribe(
      (res) => {
        if (res["status"] == 1) {
          this.orderDetailsRes = res["data"][0]["orderDetails"];
          this.totalNoofSesstions=this.orderDetailsRes[0]?.order?.business?.repeats * this.orderDetailsRes[0]?.order?.business?.sessionsPerDay;
          this.labAvailableTimingsRes = res["labTimings"];
          this.orderDetailsRes[0].order.orderitem.map((item:any)=>{
          this.roleBasedValue =item.roleBasedService
            console.log(`roleBasedValue`, item.roleBasedService);
          })

          if (this.orderDetailsRes != undefined && this.orderDetailsRes != null) {
            this.showButtons(actionButtonConfiguration, this.orderDetailsRes);
            this.contactNumber = this.orderDetailsRes[0].order.patientinfo.contact;
            this.emailAddress = this.orderDetailsRes[0].order.patientinfo.email;
            this.activeComponentId = this.orderDetailsRes[0].active_component;
            this.getdocuments = this.orderDetailsRes[0].order.documents;
            if(this.getdocuments){
              this.getFinalReportDocId = this.orderDetailsRes[0].order.documents.filter(x => x.finalReport == 1);
              if(this.getFinalReportDocId.length > 0){
                this.isReportInput = false;
              }
            }
            console.log(`filterFinalReport`, this.getFinalReportDocId)
            if(this.orderDetailsRes[0].order.patientinfo.service_type == '4'){
              this.serviceType = 'Radiology';
              this.uploadForm.patchValue({
                documentType:'imagingreport',
              })
            }else if(this.orderDetailsRes[0].order.patientinfo.service_type == '3'){
              this.serviceType = 'Pathology';
              this.uploadForm.patchValue({
                documentType:'labreport',
              })
            }else if(this.orderDetailsRes[0].order.patientinfo.service_type == '2'){
              this.serviceType = 'Medicines';
            }else if(this.orderDetailsRes[0].order.patientinfo.service_type == '1'){
              this.serviceType = 'Doctor Consultation';
            }else if(this.orderDetailsRes[0].order.patientinfo.service_type == '5'){
              this.serviceType = 'Care at Home';
            }else if(this.orderDetailsRes[0].order.patientinfo.service_type == '6'){
              this.serviceType = 'Nursing';
            }else if(this.orderDetailsRes[0].order.patientinfo.service_type == '7'){
              this.serviceType = 'Physiotherapy';
            }else if(this.orderDetailsRes[0].order.patientinfo.service_type == '8'){
              this.serviceType = 'Bedside Attendant';
            }else if(this.orderDetailsRes[0].order.patientinfo.service_type == '9'){
              this.serviceType = 'Speciality';
            }else if(this.orderDetailsRes[0].order.patientinfo.service_type == '10'){
              this.serviceType = 'Doctor';
            }else if(this.orderDetailsRes[0].order.patientinfo.service_type == '11'){
              this.serviceType = 'Medical Equipment Buying & Rental';
            }else if(this.orderDetailsRes[0].order.patientinfo.service_type == '12'){
              this.serviceType = 'Emotional Wellbeing Psychiatry & Psychology';
            }else if(this.orderDetailsRes[0].order.patientinfo.service_type == '13'){
              this.serviceType = 'Second Opinion';
            }else if(this.orderDetailsRes[0].order.patientinfo.service_type == '14'){
              this.serviceType = 'MyWellness';
            }else if(this.orderDetailsRes[0].order.patientinfo.service_type == '15'){
              this.serviceType = 'Family Doctor';
            }else if(this.orderDetailsRes[0].order.patientinfo.service_type == '16'){
              this.serviceType = 'BloodConnect';
            }else if(this.orderDetailsRes[0].order.patientinfo.service_type == '19'){
              this.serviceType = 'Diagnostics Others';
            }else if(this.orderDetailsRes[0].order.patientinfo.service_type == '100'){
              this.serviceType = 'Package';
            }

            if(this.orderDetailsRes[0].mode_of_service == 1){
              this.serviceMode = 'At Home';
            }else if(this.orderDetailsRes[0].mode_of_service == 2){
              this.serviceMode = 'At Center';
            }else if(this.orderDetailsRes[0].mode_of_service == 3){
              this.serviceMode = 'At Platform';
            }
              this.modeOfService = this.serviceType +' '+ '('+this.serviceMode+')';

            if (this.orderDetailsRes[0].order.provider_info[0].associate_name == "") {
              this.showVendor=false
            } else if (this.orderDetailsRes[0].order.provider_info[0].associate_name != "") {
              this.showVendor = true
            }

          }
        }
        // this.openReAllocateData();
        this.SpinnerService.hide();
      }

    )
  }
  openBackDropCustomClass(content) {
    this.modalService.open(content, { windowClass: 'commonStyleModals' });
  }
  openAddTestModal() {
    const modalRef = this.modalService.open(AddTestModalComponent);
    const closeModelRef = modalRef.result.then(
      (res) => {

        this.getOrderDataById(this.id);

      }

    );
    modalRef.componentInstance.associate_name = this.orderDetailsRes[0].order.provider_info[0].associate_name;
    modalRef.componentInstance.associate_id = this.orderDetailsRes[0].order.provider_info[0].associate_id;
    modalRef.componentInstance.branch_id = this.orderDetailsRes[0].order.provider_info[0].associate_branch_id;
    modalRef.componentInstance.pincode = this.orderDetailsRes[0].order.patientinfo.pincode;
    modalRef.componentInstance.order_id = this.orderDetailsRes[0].order.patientinfo.order_id;
    modalRef.componentInstance.line_items = this.orderDetailsRes[0].order.orderitem;
    modalRef.componentInstance.business_id = this.orderDetailsRes[0].order.patientinfo.service_type;
    modalRef.componentInstance.channel_code = this.orderDetailsRes[0].channel;
    modalRef.componentInstance.org_code = this.orderDetailsRes[0].orgCode;
    modalRef.componentInstance.tenant_code = this.orderDetailsRes[0].tenantCode;


  }

  openDeleteItemModal(orderItemObj) {


    const modalRef = this.modalService.open(DeleteItemModalComponent);
    const closeModelRef = modalRef.result.then(
      (res) => {

        this.getOrderDataById(this.id);

      }

    );
    modalRef.componentInstance.item_code = orderItemObj.item_code;

    modalRef.componentInstance.order_id = this.orderDetailsRes[0].order.patientinfo.order_id;
    modalRef.componentInstance.business_id = this.orderDetailsRes[0].order.patientinfo.service_type;
    modalRef.componentInstance.channel_code = this.orderDetailsRes[0].channel;

  }

  sendUrl() {
    let orderRequest = {};
    orderRequest["method"] = "OMS/api/operation.php/v1/orders/notification/send/prescription-upload-link";
    orderRequest["type"] = "post";
    orderRequest["order_id"] = this.id;
    orderRequest["component_id"] = this.activeComponentId;
    orderRequest["source"] = "CCO";
    orderRequest["channelCode"] = this.constantsService.CHANNEL_CODE;
    orderRequest["actionById"] = window.localStorage.getItem('actionById');;

    this.omsServiceService.sendPrescriptionUrl(orderRequest).subscribe(
      (res) => {
        this.prescriptionResponse = res["message"];
        this.isPrescriptionSend = true;


        if (res["success"] == 1) {
          this.changeStatusBasedOnPrescription(this.id);
        }
      }
    )
  }
  sendPrescriptionUrl() {
    this.sendUrl();
  }
  sendOtpRequestInfo(contactNumber: string, email: string) {
    let orderRequest = {};
    orderRequest["method"] = "api/otp/generate";
    orderRequest["type"] = "post";
    orderRequest["mobile"] = contactNumber;
    orderRequest["component_id"] = "9";
    orderRequest["email"] = email;
    orderRequest["keyValue"] = "MHO00213";
    orderRequest["keyType"] = "ISP";
    orderRequest["sourceType"] = "Mobile-APP";
    orderRequest["channelCode"] = this.constantsService.CHANNEL_CODE;
    this.omsServiceService.sendOtp(orderRequest).subscribe(
      (res) => {

        this.otpResponse = res["message"];
        this.isOtpSend = true;
        if (res["success"] == 1) {
        }
      }
    )
  }
  sendOtp() {
    this.sendOtpRequestInfo(this.contactNumber, this.emailAddress);
  }
  paymentDifferenceInfo(id: number, email: string, contactNumber: string, orderId) {
    let orderRequest = {};
    orderRequest["mode"] = "2";
    orderRequest["channel"] = "CP";
    orderRequest["id"] = [id];
    orderRequest["email"] = email;
    orderRequest["phone"] = contactNumber;
    orderRequest["action"] = "OMS/api/operation.php/v1/orders/payments/link/send";
    orderRequest["type"] = "post";

    this.omsServiceService.paymentDifference(orderRequest).subscribe(
      (res) => {
        this.paymentDiffResponse = res["message"];
        this.isPaymentDifferences = true;
        this.getOrderDataById(orderId);

      }
    )
  }
  paymentDiff(orderId) {
    this.paymentDifferenceInfo(this.id, this.emailAddress, this.contactNumber, orderId);
  }


  openResignItemModal(orderItemObj) {

    const modalRef = this.modalService.open(ItemsReassignModalComponent);
    const closeModelRef = modalRef.result.then(
      (res) => {
        this.getOrderDataById(this.id);
      }

    );
    modalRef.componentInstance.line_items = orderItemObj.order.orderitem;
    modalRef.componentInstance.delivery_lat = orderItemObj.order.patientinfo.delivery_lat;
    modalRef.componentInstance.delivery_lng = orderItemObj.order.patientinfo.delivery_lng;
    modalRef.componentInstance.pincode = orderItemObj.order.patientinfo.pincode;
    modalRef.componentInstance.mode_of_service = orderItemObj.mode_of_service;
    modalRef.componentInstance.order_id = orderItemObj.order.patientinfo.order_id;
    modalRef.componentInstance.business_id = this.orderDetailsRes[0].order.patientinfo.service_type;
    modalRef.componentInstance.provider_info = this.orderDetailsRes[0].order.provider_info;
    modalRef.componentInstance.org_code = this.orderDetailsRes[0].orgCode;
    modalRef.componentInstance.tenant_code = this.orderDetailsRes[0].tenantCode;
    modalRef.componentInstance.labAvailable_TimingsRes = this.labAvailableTimingsRes;


  }



  openReScheduleItemModal(orderObj, obj) {
    console.log(`orderObj`, orderObj,obj);
    
    const modalRef = this.modalService.open(ReScheduleItemComponent);

    const closeModelRef = modalRef.result.then(
      (res) => {

        this.getOrderDataById(this.id);

      }

    );
    modalRef.componentInstance.delivery_lat = orderObj.order.patientinfo.delivery_lat;
    modalRef.componentInstance.delivery_lng = orderObj.order.patientinfo.delivery_lng;
    modalRef.componentInstance.pincode = orderObj.order.patientinfo.pincode;
    modalRef.componentInstance.mode_of_service = orderObj.mode_of_service;
    modalRef.componentInstance.order_id = orderObj.order.patientinfo.order_id;
    modalRef.componentInstance.order_status = orderObj.order.order_status;
    modalRef.componentInstance.orderObj = orderObj;
    modalRef.componentInstance.business_id = this.orderDetailsRes[0].order.patientinfo.service_type;
    modalRef.componentInstance.total_amount=orderObj.payment_info.paid_amount;
    modalRef.componentInstance.service_did=orderObj.order.orderitem[0].item_code;
    if (obj == 1) {
      modalRef.componentInstance.isReScheduleOrder = true;
      modalRef.componentInstance.isConfirmedOrder = false;
    } else if(obj == 15){
      modalRef.componentInstance.isReqCancelledOrder = true;
    } else if(obj == 16){
      modalRef.componentInstance.isReqReScheduleOrder = true;
    } 
    else if(obj == 8){
      modalRef.componentInstance.isCancelOrder = true;
    }  else if(obj == 'forceReschedule'){
      modalRef.componentInstance.isForceReschedule = true;
    }else {
      modalRef.componentInstance.isReScheduleOrder = false;
      modalRef.componentInstance.isConfirmedOrder = true;
    }
    modalRef.componentInstance.org_code = orderObj.orgCode;
    modalRef.componentInstance.tenant_code = orderObj.tenantCode;

    modalRef.componentInstance.patient_gender = orderObj.order.patientinfo.gender;
    modalRef.componentInstance.patient_mrn = orderObj.order.patientinfo.mrn;
    modalRef.componentInstance.patient_age = orderObj.order.patientinfo.age;
    modalRef.componentInstance.preferred_officer = orderObj.order.provider_info.associate_id;
    modalRef.componentInstance.preferred_time = orderObj.order.patientinfo.scheduled_date;    
    modalRef.componentInstance.isReqStatus = obj;

  }

  changeStatusBasedOnPrescription(orderId) {
    let prescrionPrndingStatusRequest = {};


    prescrionPrndingStatusRequest["order_id"] = orderId;
  
    prescrionPrndingStatusRequest["actionById"] = window.localStorage.getItem('actionById');
    prescrionPrndingStatusRequest["actionByName"] = window.localStorage.getItem('actionByName');
    prescrionPrndingStatusRequest["source"] = "1";
    prescrionPrndingStatusRequest["status"] = this.constantsService.PRESCRIPTION_PENDING_STATUS;
    prescrionPrndingStatusRequest["channelCode"] = this.constantsService.CHANNEL_CODE;
    prescrionPrndingStatusRequest["action"] = "OMS/api/operation.php/v1/order/change/status";
    prescrionPrndingStatusRequest["type"] = "post";
    //channelCode
    this.omsServiceService.changeStatusBasedOnPrescription(prescrionPrndingStatusRequest).subscribe(
      (res) => {
        //console.log(res);
      }
    )
  }

  openOrderCancelPopup(type,orderObj) {
    const modalRef = this.modalService.open(OrderCancelModelComponent, { windowClass: 'commonStyleModals' });
    const closeModelRef = modalRef.result.then(
      (res) => {

        this.getOrderDataById(this.id);

      }

    );

    modalRef.componentInstance.orderObj = orderObj;
    modalRef.componentInstance.channel_code = this.orderDetailsRes[0].channel;
    modalRef.componentInstance.isCancelOrderType = type;
  }

  orderCancel(orderId) {

    let orderCancelRequest = {};
    orderCancelRequest["order_id"] = [orderId];
    orderCancelRequest["reason"] = "";
    orderCancelRequest["reason_text"] = "";
    orderCancelRequest["comment"] = "";
    orderCancelRequest["scheduled_date"] = "";
    orderCancelRequest["reasonType"] = "";
    orderCancelRequest["actionById"] = window.localStorage.getItem('actionById');
    orderCancelRequest["actionByName"] = window.localStorage.getItem('actionByName');
    orderCancelRequest["source"] = "1";
    orderCancelRequest["role"] = "";
    orderCancelRequest["channelCode"] = this.constantsService.CHANNEL_CODE;
    orderCancelRequest["categoryId"] = "25";
    orderCancelRequest["action"] = "OMS/api/operation.php/v1/orderCancel";
    orderCancelRequest["type"] = "post";

    this.omsServiceService.orderCancel(orderCancelRequest).subscribe(
      (res) => {
        this.toastr.success(res["msg"]);
      }
    )

  }

  orderReject(orderId) {
    let orderRejectRequest = {};
    orderRejectRequest["order_id"] = orderId;
    orderRejectRequest["actionByName"] = window.localStorage.getItem('actionByName');
    orderRejectRequest["actionById"] = window.localStorage.getItem('actionById');;
    orderRejectRequest["source"] = "1";
    orderRejectRequest["status"] = 9;
    orderRejectRequest["channelCode"] = this.constantsService.CHANNEL_CODE;
    orderRejectRequest["reason"] = "test";
    orderRejectRequest["action"] = 'OMS/api/operation.php/v1/order/change/status';
    orderRejectRequest["type"] = 'post';
    this.omsServiceService.orderReject(orderRejectRequest).subscribe(
      (res) => {
        this.toastr.success(res["message"]);
        this.getOrderDataById(orderId);
      }
    )

  }

  openUploadReportItemModal(orderObj) {
    const modalRef = this.modalService.open(UploadReportDataComponent, { windowClass: 'commonStyleModals' });

    const closeModelRef = modalRef.result.then(
      (res) => {

        this.getOrderDataById(this.id);

      }

    );

    modalRef.componentInstance.orderObj = orderObj;
    modalRef.componentInstance.isUploadReportButton = this.isUploadReport;
    modalRef.componentInstance.isUploadReportButtonReady = this.isUploadButtonReady;
    modalRef.componentInstance.org_code = this.orderDetailsRes[0].orgCode;
    modalRef.componentInstance.tenant_code = this.orderDetailsRes[0].tenantCode;
  }

  homePage() {


    this.sharedService.sessionId.subscribe(val => {

      this.sessionId = val;
    });
    this.sharedService.requestFrom.subscribe(val => {

      this.from = val;
    });

    this._router.navigate(['/orders']);
  }


  openVerifyOtpPopup(orderObj) {
    const modalRef = this.modalService.open(VerityOtpComponent, { windowClass: 'commonStyleModals' });

    const closeModelRef = modalRef.result.then(
      (res) => {

        this.getOrderDataById(this.id);

      }

    );

    modalRef.componentInstance.orderObj = orderObj;
    modalRef.componentInstance.isRendOtp = this.isRendOtp;
    modalRef.componentInstance.isSendOtp = this.isSendOtp;


  }

  showButtons(actionButtonConfiguration, res) {
    this.setDefaultValues();
    let isUcdOrder = "";

    if (res["0"].order.business.isUCDOrder != null && res["0"].order.business.isUCDOrder != undefined && res["0"].order.business.isUCDOrder)
      isUcdOrder = res["0"].order.business.isUCDOrder;
    let role = localStorage.getItem('role');
    let status = res[0].OStatus;
    console.log("order status=" + status);


    //verifyOTP 
    let verifyOtpObj = this.getConfigurationData(actionButtonConfiguration[0].verifyOTP, role);
    var verifyOtpStatus = verifyOtpObj["status"];
    if (verifyOtpStatus !=null && verifyOtpStatus !=undefined && verifyOtpStatus.includes(status)) {
      // this.isOtpVerifyLink = true;
      if (role == "superadmin") {

        if (isUcdOrder != "" && isUcdOrder != undefined && isUcdOrder == "1") {
          this.isOtpVerifyLink = true;
        }
        if(status == '2'){ //opd_c
          this.isOtpVerifyLink = true;
        }else if(status == '7'){
          this.isOtpVerifyLink = true;
        }
      }
      else {
        this.isOtpVerifyLink = true;
      }
    }
    //sendPrescriptionLink
    let sendPrescriptionLinkObj = this.getConfigurationData(actionButtonConfiguration[0].sendPrescriptionLink, role);
    var sendPrescriptionLinkObjStatus = sendPrescriptionLinkObj["status"];
    if (sendPrescriptionLinkObjStatus !=null && sendPrescriptionLinkObjStatus !=undefined && sendPrescriptionLinkObjStatus.includes(status)) {
      this.isSendPrescriptionLink = true;
    }
    //sendPaymentLink
    let viewPaymentLinkObj = this.getConfigurationData(actionButtonConfiguration[0].viewPaymentLink, role);
    var viewPaymentLinkObjStatus = viewPaymentLinkObj["status"];
    // if (viewPaymentLinkObjStatus != undefined) {
    //   this.isViewPaymentLink = true;
    // }


    //order cancel
    let orderCancelObj = this.getConfigurationData(actionButtonConfiguration[0].orderCancel, role);
    var orderCancelObjStatus = orderCancelObj["status"];
    if (orderCancelObjStatus != undefined && orderCancelObjStatus.includes(status)) {
      this.isOrderCancel = true;
    }

    //uploadReport

    let uploadReportObj = this.getConfigurationData(actionButtonConfiguration[0].uploadReport, role);
    var uploadReportObjStatus = uploadReportObj["status"];
    console.log(`uploadReportObjStatus`,uploadReportObjStatus)
    if (uploadReportObjStatus.includes(status)) {
      if (role == "superadmin") {
        //if (isUcdOrder != "" && isUcdOrder != undefined && isUcdOrder == "1") {
          this.isUploadReport = true;
       // }
      } else {
        if (uploadReportObjStatus !=null && uploadReportObjStatus !=undefined && uploadReportObjStatus.includes(status)) {
          this.isUploadReport = true;
        }


      }

    }
    // ViewReport

    let ViewReportObj = this.getConfigurationData(actionButtonConfiguration[0].viewReport, role);
    var ViewReportObjStatus = ViewReportObj["status"];
    this.isViewReport = true;

    //ReAssign
    let reAssignObj = this.getConfigurationData(actionButtonConfiguration[0].reAssign, role);
    var reAssignObjObjStatus = reAssignObj["status"];
    if (reAssignObjObjStatus != undefined && reAssignObjObjStatus.includes(status)  && actionButtonConfiguration[0].tenantCodesDrl.indexOf(res["0"].tenantCode) < 0  && actionButtonConfiguration[0].orgCodesDrl.indexOf(res["0"].orgCode) < 0 ) {
      this.isReAssign = true;
    }

    //isAddItem

    let addItemObj = this.getConfigurationData(actionButtonConfiguration[0].addItem, role);
    var addItemObjStatus = addItemObj["status"];
    if (addItemObjStatus != undefined && addItemObjStatus.includes(status) && actionButtonConfiguration[0].tenantCodesDrl.indexOf(res["0"].tenantCode) < 0  && actionButtonConfiguration[0].orgCodesDrl.indexOf(res["0"].orgCode) < 0  ) {
      this.isAddItem = true;
    }
    //isDeleteItem:boolean =false;
    let deleteItemObj = this.getConfigurationData(actionButtonConfiguration[0].deleteItem, role);
    var deleteItemObjStatus = deleteItemObj["status"];
    if (deleteItemObjStatus != undefined && deleteItemObjStatus.includes(status)  && actionButtonConfiguration[0].tenantCodesDrl.indexOf(res["0"].tenantCode) < 0  && actionButtonConfiguration[0].orgCodesDrl.indexOf(res["0"].orgCode) < 0 ) {
      this.isDeleteItem = true;
    }

    //isReScheduleOrder:boolean=false;
    let reScheduleOrderObj = this.getConfigurationData(actionButtonConfiguration[0].reScheduleOrder, role);
    var reScheduleOrderObjStatus = reScheduleOrderObj["status"];
    if (reScheduleOrderObjStatus != undefined && reScheduleOrderObjStatus.includes(status) && actionButtonConfiguration[0].tenantCodesDrl.indexOf(res["0"].tenantCode) < 0  && actionButtonConfiguration[0].orgCodesDrl.indexOf(res["0"].orgCode) < 0) {
      this.isReScheduleOrder = true;
    }

    ////isConfirmScheduleDate:boolean=false;
    let confirmScheduleDateObj = this.getConfigurationData(actionButtonConfiguration[0].confirmScheduleDate, role);
    var confirmScheduleDateObjStatus = confirmScheduleDateObj["status"];
    if (confirmScheduleDateObjStatus != undefined && confirmScheduleDateObjStatus.includes(status)) {
      this.isConfirmScheduleDate = true;
    }

    //isOrderReject
    let orderRejectObj = this.getConfigurationData(actionButtonConfiguration[0].orderReject, role);
    var orderRejectObjStatus = orderRejectObj["status"];

    if ((orderRejectObjStatus.includes(status))) {
      if (role == "superadmin") {
        var orderRejectConditions = orderRejectObj["forSpacialOnly"];
        if (isUcdOrder != "" && isUcdOrder != undefined && isUcdOrder == "1") {
          this.isOrderReject = true;
        }
      }
      else {
        this.isOrderReject = true;
      }

    }
    //viewPrescriptionLink
    let viewPrescriptionLinkObj = this.getConfigurationData(actionButtonConfiguration[0].viewPrescriptionLink, role);
    var viewPrescriptionLinkObjStatus = viewPrescriptionLinkObj["status"];
    if (viewPrescriptionLinkObjStatus.includes("-1")) {
      this.isViewPrescriptionLink = true;
    }


    //orderComplete
    let orderCompleteObj = this.getConfigurationData(actionButtonConfiguration[0].orderComplete, role);
    var orderCompleteObjStatus = orderCompleteObj["status"];
    if (orderCompleteObjStatus.includes(status)) {

      if (role == "superadmin") {
          this.isOrderComplete = true;
      }
      else {
        this.isOrderComplete = true;
      }

    }

    //resentOTP
    let resentOTPObj = this.getConfigurationData(actionButtonConfiguration[0].resentOTP, role);
    var resentOTPObjStatus = resentOTPObj["status"];
    if (resentOTPObjStatus.includes(status)) {

      if (role == "superadmin") {
        var orderRejectConditions = orderRejectObj["forSpacialOnly"];
        if (isUcdOrder != "" && isUcdOrder != undefined && isUcdOrder == "1") {
          this.isRendOtp = true;
        }
      }
      else {
        this.isRendOtp = true;
      }

    }

    //sentOTP

    let sentOTPObj = this.getConfigurationData(actionButtonConfiguration[0].sentOTP, role);
    var sentOTPObjStatus = sentOTPObj["status"];
    if (sentOTPObjStatus != "" && sentOTPObjStatus != undefined && sentOTPObjStatus.includes(status)) {
      this.isSendOtp = true;
    }

    let prescriptionUploadReportObj = this.getConfigurationData(actionButtonConfiguration[0].uploadPrescriptionLink, role);
    var uploadReportObjStatus = prescriptionUploadReportObj["status"];
    if (uploadReportObjStatus !=null && uploadReportObjStatus !=undefined && uploadReportObjStatus.includes(status)) {
      this.isPrescriptionUploadButton = true;

    }

    let isUploadButtonReadyObj = this.getConfigurationData(actionButtonConfiguration[0].uploadReportReady, role);
    var isUploadButtonReadyObjStatus = isUploadButtonReadyObj["status"];
    if (isUploadButtonReadyObjStatus.includes(status)) {
      this.isUploadButtonReady = true;

    }

  }

  getConfigurationData(listOfData, role) {
    let obj = {};
    for (let data of listOfData) {

      if (role == data.role) {
        obj = data;
      }

    }
    return obj;
  }

  orderComplete(orderId) {
    let orderCancelRequest = {};
    orderCancelRequest["order_id"] = orderId;
    orderCancelRequest["actionByName"] = window.localStorage.getItem('actionByName');
    orderCancelRequest["actionById"] = window.localStorage.getItem('actionById');;
    orderCancelRequest["source"] = "1";
    orderCancelRequest["status"] = 6;
    orderCancelRequest["channelCode"] = this.constantsService.CHANNEL_CODE;
    orderCancelRequest["reason"] = "test";
    //changeStatusUrl
    this.omsServiceService.orderComplete(orderCancelRequest).subscribe(
      (res) => {
        this.toastr.success(res["message"]);
        this.homePage();
      }
    )

  }

  openPrescriptionUploadReportModal(orderObj) {
    const modalRef = this.modalService.open(PrescriptionUploadComponent);

    const closeModelRef = modalRef.result.then(
      (res) => {

        this.getOrderDataById(this.id);

      }

    );

    modalRef.componentInstance.orderObj = orderObj;
    modalRef.componentInstance.isPrescriptionUploadReportBtn = this.isPrescriptionUploadButton;
    modalRef.componentInstance.channel_code = this.orderDetailsRes[0].channel;

  }

  openOrderRejectPopup(orderObj) { //orderObj
    const modalRef = this.modalService.open(OrderRejectModalComponent, { windowClass: 'commonStyleModals' });
    const closeModelRef = modalRef.result.then(
      (res) => {
        this.getOrderDataById(this.id);
      }
    );

    modalRef.componentInstance.order_id = orderObj;
    modalRef.componentInstance.channel_code = this.orderDetailsRes[0].channel;
  }

  setDefaultValues() {

    this.isPrescriptionSend = false;
    //this.isPaymentDifferences = false;
    this.isConfirmedOrder = false;
    this.isOtpSend = false;
    this.isPendingPrescriptionLink = false;
    this.isPendingPrescriptionLinkStatus = false;
    this.isSendPaymentLink = false;
    this.isOrderComplete = false;
    this.isUploadReport = false;
    this.isOtpVerifyLink = false;
    this.isPrescriptionLink = false;
    this.isOrderCancel = false;
    this.isReAssign = false;
    this.isAddItem = false;
    this.isDeleteItem = false;
    this.isConfirmScheduleDate = false;
    this.isReScheduleOrder = false;
    this.isViewPrescriptionLink = false;
    this.isSendPrescriptionLink = false;
    this.isViewReport = false;
    this.isOrderReject = false;
    // this.isViewPaymentLink = false;
    this.isRendOtp = false;
    this.isSendOtp = false;
    this.isUploadButtonReady = false;

  }

  closePopup() {
    this.isPaymentDifferences = false;
    this.modalService.dismissAll();
    this.getOrderDataById(this.id);
  }

    customerCheckIn(obj) {

    let customerCheckInRequest = {};

     if (document.getElementById('reason') != undefined) {
       let reason = (<HTMLInputElement>document.getElementById('reason')).value;
       customerCheckInRequest["reason"] = reason;
     }
    customerCheckInRequest["order_id"] = [obj.order.patientinfo.order_id];
    customerCheckInRequest["actionById"] = window.localStorage.getItem('actionById');;
    customerCheckInRequest["actionByName"] = window.localStorage.getItem('actionByName');;
    customerCheckInRequest["source"] = "1";
    customerCheckInRequest["status"] = 301;
    customerCheckInRequest["channelCode"] = this.constantsService.CHANNEL_CODE;
    customerCheckInRequest["type"] = "post";
    customerCheckInRequest["action"] = "OMS/api/operation.php/v1/order/change/status";
    this.omsServiceService.orderConfirmation(customerCheckInRequest).subscribe(
      (res) => {
        if (res["status"] == 1) {
          this.toastr.success(res["message"]);
          this.getOrderDataById(this.id);
         }else{
          this.toastr.success(res["message"]);
          this.getOrderDataById(this.id);
         }

      });

  }

    onSubmit(orderId) {
    if (this.uploadForm.get('documentType').value != "" && this.uploadForm.get('documentType').value != null && this.uploadForm.get('documentType').value != undefined) {
          if (this.uploadForm.get('profile').value != "" && this.uploadForm.get('profile').value != null && this.uploadForm.get('profile').value != undefined) {
            let formData = new FormData();
            // formData.append('file[]', this.uploadForm.get('profile').value);
            formData.append('file[]',this.uploadFile);

            formData.append("order_id", orderId);
            formData.append("channelCode",this.constantsService.CHANNEL_CODE);
            formData.append("actionById", window.localStorage.getItem('actionById'));
            formData.append("actionByName", window.localStorage.getItem('actionByName'));
            formData.append("source", "2");
            formData.append("uploadedFrom", "SDM");
            formData.append("documentType", this.uploadForm.get('documentType').value);
            if(this.uploadForm.get('finalReport').value){
              formData.append("final_report", "1");
            }else{
              formData.append("final_report", "0");
            }
            this.SpinnerService.show()
            this.omsServiceService.uploadFile(formData).subscribe(
              (res) => {
                this.SpinnerService.hide()
                if(res["status"]==1)
                {
                  this.toastr.success(res["message"]);
                  this.getOrderDataById(this.id);
                  this.uploadForm.reset()
                  // setTimeout(function(){
                  //     location.reload();
                  // }, 500);
                }else{
                  this.toastr.error(res["message"]);
                }
              })
      } else {
        this.toastr.error("please select file to upload");
      }
    } else {
      this.toastr.error("please select document type");
    }

  }

    changeOrderStatus(orderId,documents='') {
    if(documents !=undefined && documents.length >0)
    {

    this.SpinnerService.show();
    let orderStatusChangeRequest = {};
    orderStatusChangeRequest["order_id"] = orderId;
    orderStatusChangeRequest["actionByName"] = window.localStorage.getItem('actionByName');
    orderStatusChangeRequest["actionById"] = window.localStorage.getItem('actionById');;
    orderStatusChangeRequest["source"] = "1";
    orderStatusChangeRequest["status"] = this.constantsService.REPORT_UPLOADED_STATUS;
    orderStatusChangeRequest["channelCode"] = this.constantsService.CHANNEL_CODE;
    orderStatusChangeRequest["action"] = "OMS/api/operation.php/v1/order/change/status";
    orderStatusChangeRequest["type"] = "post";
    this.omsServiceService.changeStatusBasedOnReportUpload(orderStatusChangeRequest).subscribe(
      (res) => {
        this.toastr.success(res["message"]);
        this.SpinnerService.hide();
        this.getOrderDataById(orderId);
      }
    )
    }else{
      this.toastr.error("No Records Uploaded");
    }
    

  }

    reportIsReady(orderId)
  { 

    this.SpinnerService.show();
    let orderStatusChangeRequest = {};
    orderStatusChangeRequest["order_id"] = orderId;
    orderStatusChangeRequest["actionByName"] = window.localStorage.getItem('actionByName');
    orderStatusChangeRequest["actionById"] = window.localStorage.getItem('actionById');
    orderStatusChangeRequest["source"] = "1";
    orderStatusChangeRequest["status"] = this.constantsService.REPORT_UPLOAD_READY_STATUS;
    orderStatusChangeRequest["channelCode"] = this.constantsService.CHANNEL_CODE;
    orderStatusChangeRequest["action"] = "OMS/api/operation.php/v1/order/change/status";
    orderStatusChangeRequest["type"] = "post";
    this.omsServiceService.changeStatusBasedOnReportUpload(orderStatusChangeRequest).subscribe(
      (res) => {
        this.toastr.success(res["message"]);
        this.SpinnerService.hide();
        this.getOrderDataById(orderId);
      }
    )
  }

    delete(docId,docName,orderId)
  {
    if(docId !=undefined && docName !=undefined)
    {
    let deleteFileRequest ={};
    deleteFileRequest["order_id"]=orderId;
    deleteFileRequest["doc_id"]=docId;
    deleteFileRequest["filename"]=docName;
    deleteFileRequest["channelCode"]=this.constantsService.CHANNEL_CODE;
    deleteFileRequest["actionById"]=window.localStorage.getItem('actionById');
    deleteFileRequest["action"]="OMS/api/uploader.php/v4/orders/prescriptions/delete";
    deleteFileRequest["type"]="post";
    this.omsServiceService.deletePrescription(deleteFileRequest).subscribe(
      (res) => {
        if(res["status"]==1)
        {
        this.toastr.success(res["message"]);
        this.getOrderDataById(orderId);
        }else{
          this.toastr.error(res["message"]);
        }
      }
    )

    }else{
      this.toastr.error("please upload accurate file and then delete");
    }
    
  }

  download(docId)
  {

    let downloadFileRequest ={};
    downloadFileRequest["doc_id"]=docId;
    downloadFileRequest["action"]="OMS/api/uploader.php/v4/orders/document/id";
    downloadFileRequest["type"]="post";
    this.omsServiceService.downloadFile(downloadFileRequest).subscribe(
      (res) => {
        if(res["status"]==1)
        {
          window.open(res["data"].url,'_blank');
        
        }
      }
    )
  }

    resendReport(docId,docName,orderId)
  {
    if(docId !=undefined && orderId !=undefined)
    {
    let resendFileRequest ={};
    resendFileRequest["orderId"]=orderId;
    resendFileRequest["documentId"]=docId;
    resendFileRequest["documentName"]=docName;
    resendFileRequest["channelCode"]=this.constantsService.CHANNEL_CODE;
    resendFileRequest["actionById"]=window.localStorage.getItem('actionById');
    resendFileRequest["actionByName"]=window.localStorage.getItem('actionByName');
    resendFileRequest["action"]="OMS/api/uploader.php/v6/report/resend";
    resendFileRequest["type"]="post";
    this.omsServiceService.resendFinalReport(resendFileRequest).subscribe(
      (res) => {
        if(res["status"]==1)
        {
        this.toastr.success(res["message"]);
        this.getOrderDataById(orderId);
        }else{
          this.toastr.error(res["message"]);
        }
      }
    )
    }else{
      this.toastr.error("please upload accurate file and then delete");
    }
    
  }

  getpreview(docId)
  {
    if(docId !=undefined)
    {
    let getpreviewRequest ={};
    getpreviewRequest["doc_id"]=docId;
    this.omsServiceService.getDocumentUrl(getpreviewRequest).subscribe(
      (res) => {
        console.log("getpreviewRequest=" + JSON.stringify(res))
        if(res["status"]=="SUCCESS")
        {
        this.toastr.success(res["message"]);
        }else{
          this.toastr.error(res["message"]);
        }
      }
    )

    }else{
      this.toastr.error("please upload accurate file and then delete");
    }
    
  }

  openReAllocateData() {
    
    let omsorder_id = this.orderDetailsRes[0].order.patientinfo.order_id;
    let omsschedule_date = this.orderDetailsRes[0].order.patientinfo.scheduled_date;
    let omsworkorder_id = this.orderDetailsRes[0].wid;
    let omsassociateid = '';
    let omsbranchid = '';
    let omsapplication_no = '';
    let omsdelivery_lat = this.orderDetailsRes[0].order.patientinfo.delivery_lat;
    let omsdelivery_lng = this.orderDetailsRes[0].order.patientinfo.delivery_lng;
    let omspincode = this.orderDetailsRes[0].order.patientinfo.pincode;
    let omsis_continuous = this.orderDetailsRes[0].order.business.is_continuous;
    let omsorgCode = this.orderDetailsRes[0].orgCode;
    let omstenantCode = this.orderDetailsRes[0].tenantCode;
    let omsexistingOfficer = this.orderDetailsRes[0].order.order_status.assignedto;

    let dateTimesplit = omsschedule_date.split('.')
     dateTimesplit = dateTimesplit[0].split('T')
     omsschedule_date = dateTimesplit[0]+' '+dateTimesplit[1]

    let omsrole_id = (this.orderDetailsRes[0].order.provider_info.length == 1 ) ? this.orderDetailsRes[0].order.provider_info.role : 'loop';

     console.log(`orderDetailsRes`, this.orderDetailsRes[0])
     
     if (this.orderDetailsRes[0].active_component != "" && this.orderDetailsRes[0].active_component != null && this.orderDetailsRes[0].active_component != undefined) {
        this.orderDetailsRes[0].order.provider_info.forEach(i => {
            console.log(i.component_no)
            	if(i.component_no == this.orderDetailsRes[0].active_component)
              {
                omsrole_id = i.role;
              }
          })
			}
       let associatesRequest = {};
        associatesRequest["delivery_lat"] = omsdelivery_lat;
        associatesRequest["delivery_lng"] = omsdelivery_lng;
        associatesRequest["isInternalCall"] = 1;
        associatesRequest["orgCode"] = omsorgCode;
        associatesRequest["pincode"] = omspincode;
        associatesRequest["tenantCode"] = omstenantCode;
        associatesRequest["role_id"] = omsrole_id;
        associatesRequest["action"] = "OMS/api/operation.php/v1/fetch_nearby_associates";
        associatesRequest["type"] = "post";
        if( omsis_continuous != '1') // For continuous care plan orders, assoiate change cant be possible
        {
          this.omsServiceService.getNearbyAssociates(associatesRequest).subscribe(
          (res) => {
            this.assoc_data = res
          console.log(`fetch_nearby_associates`, this.assoc_data);
          })
        }
    /* Get Assoiates and branches near to delivery lat-lng End*/
        let officersRequest = {};
        officersRequest["scheduled_date"] = omsschedule_date;
        officersRequest["order_id"] = omsorder_id;
        officersRequest["isInternalCall"] = 1;
        officersRequest["roleType"] = omsrole_id;
        officersRequest["tenantOrgInfo"] = {"orgCode" : omsorgCode, "tenantCode" : omstenantCode};
        officersRequest["action"] = 'OMS/api/operation.php/v1/fetch_officers';
        officersRequest["type"] = 'post';

          this.omsServiceService.getNearbyOfficers(officersRequest).subscribe(
          (res) => {
            let officer_data = res
              officer_data.orderid = omsorder_id;
              officer_data.scheduled_date = omsschedule_date;
              officer_data.workorder_id = omsworkorder_id;		
              officer_data.existingOfficer = omsexistingOfficer;
              if( omsis_continuous != '1'){
              officer_data.assoc_data = this.assoc_data;
              }
              this.officerAssocInfo = officer_data;
          console.log(`fetch_nearby_officers`, this.officerAssocInfo);
          })

  }

  openReAllocateModal(status) {
    let modalRef:any;
    if(status =='createOfficer'){
      modalRef = this.modalService.open(ReAllocationComponent, { windowClass: 'commonStyleModals modalWidth90' });
    }else{
      modalRef = this.modalService.open(ReAllocationComponent);
    }
    const closeModelRef = modalRef.result.then(
      (res) => {

        // this.getOrderDataById(this.id);

      });
      modalRef.componentInstance.isorderDetailsRes = this.orderDetailsRes[0];
      if(status == 'forceAllocate'){
        modalRef.componentInstance.orderId=[this.id]
        modalRef.componentInstance.tenantCode=this.orderDetailsRes[0].tenantCode
        modalRef.componentInstance.orgCode=this.orderDetailsRes[0].orgCode
        modalRef.componentInstance.role=this.orderDetailsRes[0].order.orderitem[0].role
        modalRef.componentInstance.isSendStatus = status;
      }else if(status =='createOfficer'){
        modalRef.componentInstance.orderId=[this.id]
        modalRef.componentInstance.tenantCode=this.orderDetailsRes[0].tenantCode
        modalRef.componentInstance.orgCode=this.orderDetailsRes[0].orgCode
        modalRef.componentInstance.isSendStatus = status;
      }else{
        modalRef.componentInstance.isorderDetailsRes = this.orderDetailsRes[0];
        modalRef.componentInstance.isSendStatus = status;
      }
    // modalRef.componentInstance.isAssocInfo = this.assoc_data;
    // modalRef.componentInstance.isOfficerAssocInfo = this.officerAssocInfo;

  }

  openCollectSampleModal(status,Id,odid,barcode) {

    const modalRef = this.modalService.open(SamplesCollectedComponent, { windowClass: 'commonStyleModals modalWidth50p'});
    const closeModelRef = modalRef.result.then(
      (res) => {

      });

    modalRef.componentInstance.isSendStatus = status;
    modalRef.componentInstance.odid = odid;
    modalRef.componentInstance.barcode = barcode;
    modalRef.componentInstance.order_id = Id;
  }

  openSubmitSampleModal(status,Id) {

    const modalRef = this.modalService.open(SamplesSubmitedComponent, { windowClass: 'commonStyleModals modalWidth50p'});
    const closeModelRef = modalRef.result.then(
      (res) => {

      });

    modalRef.componentInstance.isSendStatus = status;
    modalRef.componentInstance.order_id = [Id];
  }

  CloseTab() {
    window.close();
  }

  getVendorList(){

    let orderRequest = {};
    orderRequest["systemType"] = "l2pharma";
    orderRequest["isInternalCall"] = 1;
    orderRequest["action"] = "OMS/api/medicine_supply.php/v1/vendor_list";
    orderRequest["type"] = "post";

    this.omsServiceService.getVendorList(orderRequest).subscribe(

      (res) => {

      this.vendorList=res.data

      console.log(`res`, this.vendorList);

      }

    )

  } 

  assignVendor(){

    let vendorRequest = {};
    vendorRequest["order_id"] = this.id;
    vendorRequest["actionById"] = window.localStorage.getItem('actionById');
    vendorRequest["actionByName"] = window.localStorage.getItem('actionByName');
    vendorRequest["source"] = "L2";
    vendorRequest["reason"] = "Assigned Vendor";
    vendorRequest["comment"] = "";
    vendorRequest["status"] = 21;
    vendorRequest["isInternalCall"] = 1;
    vendorRequest["action"] = "OMS/api/operation.php/v1/order/change/status";
    vendorRequest["type"] = "post";

    if(this.vendor.value != undefined || this.vendor.value != null || this.vendor.value != ""  ){
      vendorRequest["associate_id"] = this.vendor.value;
    }

    this.omsServiceService.assignVendor(vendorRequest).subscribe((res:any)=>{
      console.log(`res222222`, res);
      if(res.status == 1){
        this.toastr.success(res.message)
        this.getOrderDataById(this.id)
      }else{
        this.toastr.error(res.message)
      }    
    })
  }

    openEconsultReassignModal(orderItemObj) {

    const modalRef = this.modalService.open(EconsultReassignModalComponent);
    const closeModelRef = modalRef.result.then(
      (res) => {

        this.getOrderDataById(this.id);
      }

    );
    modalRef.componentInstance.line_items = orderItemObj.order.orderitem;
    modalRef.componentInstance.delivery_lat = orderItemObj.order.patientinfo.delivery_lat;
    modalRef.componentInstance.delivery_lng = orderItemObj.order.patientinfo.delivery_lng;
    modalRef.componentInstance.pincode = orderItemObj.order.patientinfo.pincode;
    modalRef.componentInstance.mode_of_service = orderItemObj.mode_of_service;
    modalRef.componentInstance.order_id = orderItemObj.order.patientinfo.order_id;
    modalRef.componentInstance.business_id = this.orderDetailsRes[0].order.patientinfo.service_type;
    modalRef.componentInstance.provider_info = this.orderDetailsRes[0].order.provider_info;
    modalRef.componentInstance.org_code = this.orderDetailsRes[0].orgCode;
    modalRef.componentInstance.tenant_code = this.orderDetailsRes[0].tenantCode;
    modalRef.componentInstance.labAvailable_TimingsRes = this.labAvailableTimingsRes;


  }

  openPaymentLinkModal(buttonType) {
    const modalRef = this.modalService.open(GeneratePaymentLinkComponent);
    const closeModelRef = modalRef.result.then(
      (res) => {
        this.getOrderDataById(this.id);
      }

    );
    if(buttonType == 'paymentLink'){
      modalRef.componentInstance.sendPaymentLink=true;
    }
    else if(buttonType == 'generateReceipt'){
      modalRef.componentInstance.generateReceipt=true;
    }
    modalRef.componentInstance.serviceType=this.orderDetailsRes[0].order.patientinfo.service_type
    modalRef.componentInstance.order_id = this.id;
    modalRef.componentInstance.email = this.emailAddress;
    modalRef.componentInstance.contactNumber = this.contactNumber;
    
    if(this.orderDetailsRes[0].order.patientinfo.service_type == '5' || this.orderDetailsRes[0].order.patientinfo.service_type == '6' || this.orderDetailsRes[0].order.patientinfo.service_type == '8' || this.orderDetailsRes[0].order.patientinfo.service_type == '7'){
      // modalRef.componentInstance.noOfSections=this.orderDetailsRes[0].order.business['repeats']
      modalRef.componentInstance.noOfSections=this.totalNoofSesstions
      modalRef.componentInstance.totalPayableAmount=this.orderDetailsRes[0].payment_info.totalApplicableAmount
      modalRef.componentInstance.remainingPayableAmo=this.orderDetailsRes[0].payment_info.payable_amount
    }


  }

  openConfirmModal(orderId,obj,status) {
      
    const modalRef = this.modalService.open(ConfirmModalComponent);
    const closeModelRef = modalRef.result.then(
      (res) => {

        this.getOrderDataById(this.id);

      }

    );

      modalRef.componentInstance.order_id = orderId;
    if (obj == 2) {
      modalRef.componentInstance.isEconConfirmedOrder = true;
    }else if(obj == 3){
      modalRef.componentInstance.isAtHomeStatus = status;
      modalRef.componentInstance.isAtHomeOrder = true;
    }

  }
  assessmentForm(formType:any){
  let modalRef:any;
  modalRef = this.modalService.open(PreAssessmentFormComponent, { windowClass: 'commonStyleModals modalWidth90' });

  let data={
    "assessmentType":formType,
    "orderdid":this.orderDetailsRes[0].order.order_status.order_did,
    "tenantCode" :this.orderDetailsRes[0].tenantCode,
    "orgCode" : this.orderDetailsRes[0].orgCode,
    "actionById": window.localStorage.getItem('actionById'),
    "actionByName":window.localStorage.getItem('actionByName'),
    "role":window.localStorage.getItem('role'),
    "orderId":this.id+"",
    "parentOrderId":this.id+"",
    "name":this.orderDetailsRes[0].order.patientinfo.name,
    "age":this.orderDetailsRes[0].order.patientinfo.age,
    "gender":this.orderDetailsRes[0].order.patientinfo.gender,
    "contactDetails":this.orderDetailsRes[0].order.patientinfo.contact,
    "email":this.orderDetailsRes[0].order.patientinfo.email
  }

  if(this.orderDetailsRes[0].order.business.parent_id != undefined && this.orderDetailsRes[0].order.business.parent_id != '' ){
    data['parentOrderId']=this.orderDetailsRes[0].order.business.parent_id+""
  }

  modalRef.componentInstance.assessmentData=data;
  console.log(data)
  modalRef.result.then(
    (res:any) => {
      this.getOrderDataById(this.id);

    })

}


  
}

